export default "__VITE_ASSET__krkDafsh__"